import { render, staticRenderFns } from "./FormUse.vue?vue&type=template&id=01e36889&"
import script from "./FormUse.vue?vue&type=script&lang=js&"
export * from "./FormUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports